<script>
export default {
    name: 'TableFormHandler',

    data() {
        return {
            form: {},
            key: '',
            align: 'center',
            border: false,
            reactiveClass: '',
            standardClass: '',
            successClass: '',
            errorClass: '',
            displayValue: '',
        }
    },

    created() {
        this.initForm()
        this.setInitialKey()
    },

    mounted() {
        this.setClasses()
        this.setStandardClass()
    },

    methods: {
        initForm() {},

        setInitialKey() {},

        unFocus() {},

        setDisplayValue(value) {
            if (value === null || value === '') {
                this.displayValue = '-'
            } else {
                this.displayValue = value
            }
        },

        setClasses() {
            this.standardClass = this.border
                ? `text-${this.align}`
                : `text-${this.align} border-0`
            this.successClass = `text-${this.align} bg-success text-white`
            this.errorClass = `text-${this.align} bg-danger text-white`
        },

        setSuccessClass() {
            this.reactiveClass = this.successClass
        },

        setStandardClass() {
            this.reactiveClass = this.standardClass
        },

        setErrorClass() {
            this.reactiveClass = this.errorClass
        },

        handleSuccess() {
            this.unFocus()
            this.setSuccessClass()
            setTimeout(this.setStandardClass, 700)
        },

        handleSelectSuccess() {
            this.setSuccessClass()
            setTimeout(this.setStandardClass, 700)
        },

        handleError() {
            this.unFocus()
            this.setErrorClass()
            setTimeout(this.setStandardClass, 700)
            this.initForm()
            this.key += Date.now()
        },
    },
}
</script>
